import script from "./DocsSortButton.mobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocsSortButton.mobile.vue?vue&type=script&setup=true&lang=ts"

import "./DocsSortButton.mobile.vue?vue&type=style&index=0&id=a67abe8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a67abe8c"]])

export default __exports__